import type { ProductLink } from '@atlassian/navigation-bff-data-provider';

export const productLinksWorkspaceCloudIdFilter =
	(workspaceCloudId: string) =>
	(item: ProductLink, index: number, arr: ProductLink[]): boolean => {
		const matchedItem = arr.find((productLink) => {
			return productLink.cloudId === workspaceCloudId;
		});

		// If an item exists in the parent array with the same cloudId,
		// we don't want to show a flyout and instead only want the list
		// of available product links to include the matching cloudId.
		if (matchedItem) {
			return workspaceCloudId === item.cloudId;
		}

		// If the filter gets here we want to only pass the first item
		return index === 0;
	};
